import { forwardRef } from 'react'
import { BadgeProps } from './props'
import { StyledBadge, BadgeWrapper } from './styles'

const Badge = forwardRef<HTMLSpanElement, BadgeProps>(
    (
        {
            badgeCount = 0,
            children,
            maxCount = 99,
            showBadge = true,
            variant,
            ...props
        },
        ref
    ) => {
        const badgeContent =
            variant === 'dot'
                ? ''
                : badgeCount > maxCount
                ? `${maxCount}+`
                : badgeCount < 1
                ? 1
                : badgeCount

        return (
            <BadgeWrapper>
                {children}
                <StyledBadge
                    {...props}
                    ref={ref}
                    showBadge={showBadge && badgeCount >= 1}
                    variant={variant}
                >
                    {badgeContent}
                </StyledBadge>
            </BadgeWrapper>
        )
    }
)

Badge.displayName = 'Badge'

export default Badge

export { StyledBadge }
